import createAdapter from './createAdapter'
export const optimove = createAdapter(
  () =>
    !!window.optimoveSDK &&
    optimoveSDK.API &&
    window.__OPTIMOVE_INITIALIZED === true,
  {
    page({ url, title, category, language }) {
      try {
        optimoveSDK.API.setPageVisit(url, title, category)
        optimoveSDK.API.reportEvent('page_loaded', {
          page_url: url,
          page_title: title,
          page_category: category,
          page_language: language,
        })
      } catch (error) {
        // Silence
      }
    },
    track(event, parameters = {}) {
      try {
        optimoveSDK.API.reportEvent(event, parameters)
      } catch (error) {
        // Silence
      }
    },
    user({ id, email, eventName, parameters }) {
      if (id && email) {
        optimoveSDK.API.registerUser(String(id), email, eventName, parameters)
      } else if (id) {
        optimoveSDK.API.setUserId(String(id))
      } else if (email) {
        optimoveSDK.API.setUserEmail(email)
      }
    },
  }
)
